import { useAuthState } from 'react-firebase-hooks/auth'
import { Navigate } from 'react-router-dom'

import { auth } from '@/firebase'
import { useUser } from '@/react-query/user'

const SignInRoute = ({ component }: { component: React.ReactElement }) => {
  const [firebaseUser] = useAuthState(auth)
  const userQuery = useUser()

  if (!firebaseUser || userQuery.isLoading || !userQuery.data) {
    return component
  }
  if (!firebaseUser.emailVerified) {
    return <Navigate to="/verify-email" replace />
  }

  return <Navigate to="/home" replace />
}

export default SignInRoute
